import { ReactElement } from 'react';
import { useGoogleLogin, TokenResponse } from '@react-oauth/google';
import { GoogleIcon } from 'assets/icons/icons';
import 'app/components/modules/google_auth/google_auth.scss';

function GoogleAuthLogin({
    text = 'Google',
    isLoading,
    onError,
    tokenHandler,
}: {
    text: string;
    isLoading: boolean;
    onError: () => void;
    tokenHandler: (arg: string) => void;
}): ReactElement {
    const login = useGoogleLogin({
        onSuccess: (tokenResponse: TokenResponse): void => {
            tokenHandler(tokenResponse.access_token);
        },
        onError: (): void => onError(),
    });

    return (
        <button
            className={`google-auth ${isLoading ? 'isLoading' : ''}`}
            type='button'
            onClick={() => login()}
        >
            <GoogleIcon className='google-auth__icon' />
            <span>{text}</span>
        </button>
    );
}

export default GoogleAuthLogin;
